// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3CipJ","title":"AfterFrontImage_title__125BD"};